// extracted by mini-css-extract-plugin
module.exports = {"categorySelector":"CategoryTypeController_categorySelector__pdDzN"};